const popover = {
    Popover: {
        baseStyle: {},
        sizes: {},
        variants: {
            pdpStickyMobile: {
                popper: {
                    zIndex: 150000, // needed to make paypal express button clickable
                    // This is a full-width bottom sheet, not a popover anchored to its trigger. Popper.js
                    // writes an inline `transform: translate3d(...)` (from `offset={[0,-80]}`) plus inline
                    // position/inset on this wrapper, which (a) makes it the containing block for the
                    // content's `position: fixed` and (b) offsets/narrows it — worsened by the app root's
                    // `.safe-area-wrapper` lateral padding. Pin the wrapper to the viewport and cancel
                    // Popper's inline transform so the content resolves left/right:0 to the true edges.
                    // `!important` is required because Popper sets these as inline styles.
                    position: 'fixed !important',
                    inset: 'auto 0 0 0 !important',
                    transform: 'none !important',
                    // Chakra sets `min-width: max-content` inline on the popper, which makes the sheet only
                    // as wide as its content (the DevTools showed ~780px, min-width:max-content). Force the
                    // width to the viewport and clear the min/max so it spans edge-to-edge.
                    width: '100% !important',
                    minWidth: '100% !important',
                    maxWidth: '100vw !important',
                },
                content: {
                    zIndex: 150000, // needed to make paypal express button clickable
                    boxShadow: '3px -9px 7px 0 rgba(0, 0, 0, 0.10)',
                    width: '100%',
                },
            },
        },
    },
}

export default popover
